/**
 * QUDT quantity kinds and units in the client (spec §7.4.9, §7.6.2). Shared by the reaction editor
 * and the block facts of §8.11; the server's counterpart is `kss_projection.quantities`.
 */
import { KM_NS } from "./iri";

export const QUANTITYKIND_NS = "http://qudt.org/vocab/quantitykind/";
export const UNIT_NS = "http://qudt.org/vocab/unit/";
/** kinds QUDT does not cover (Appendix A) */
export const KM_ATMOSPHERE = `${KM_NS}atmosphere`;
export const KM_YIELD = `${KM_NS}yieldPercent`;
/** kinds whose value carries no unit */
export const UNITLESS = new Set([KM_ATMOSPHERE, KM_YIELD]);

/** Display symbols for the units imported so far (`ontology/imports/qudt-unit/terms.txt`). */
const UNIT_SYMBOL: Record<string, string> = {
  DEG_C: "°C", K: "K", DEG_F: "°F", BAR: "bar", ATM: "atm", PA: "Pa", KiloPA: "kPa", MilliBAR: "mbar",
  SEC: "s", MIN: "min", HR: "h", DAY: "d", PERCENT: "%", "J-PER-MOL": "J/mol", "KiloJ-PER-MOL": "kJ/mol",
  GM: "g", MilliGM: "mg", KiloGM: "kg", MOL: "mol", MilliMOL: "mmol", MicroMOL: "µmol", L: "L", MilliL: "mL",
  MicroL: "µL", "MOL-PER-L": "mol/L",
  // general kinds for facts (maintainer, 2026-10-30)
  UNITLESS: "", NUM: "", BIT: "bit", BYTE: "B", KiloBYTE: "kB", MegaBYTE: "MB", GigaBYTE: "GB", KibiBYTE: "KiB",
  MebiBYTE: "MiB", GibiBYTE: "GiB", M: "m", KiloM: "km", CentiM: "cm", MilliM: "mm", MicroM: "µm", NanoM: "nm",
  M2: "m²", HZ: "Hz", KiloHZ: "kHz", MegaHZ: "MHz", GigaHZ: "GHz", "M-PER-SEC": "m/s", "KiloM-PER-HR": "km/h",
  J: "J", KiloJ: "kJ", "KiloW-HR": "kWh", W: "W", MilliW: "mW", KiloW: "kW", A: "A", MilliA: "mA", V: "V",
  MilliV: "mV", KiloV: "kV",
};

export function unitSymbol(unit: string | null): string {
  if (!unit) return "";
  const local = unit.startsWith(UNIT_NS) ? unit.slice(UNIT_NS.length) : unit;
  return UNIT_SYMBOL[local] ?? local;
}

/** A quantity kind as a reader sees it: "Temperature", "atmosphere", "yield (%)". */
export function kindLabel(kind: string): string {
  if (!kind) return "";
  if (kind === KM_ATMOSPHERE) return "atmosphere";
  if (kind === KM_YIELD) return "yield (%)";
  return kind.startsWith(QUANTITYKIND_NS) ? kind.slice(QUANTITYKIND_NS.length) : kind;
}
